import { attr } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const Djob = ApplicationRecord.extend({
  static: {
    jsonapiType: 'djobs',
  },
  attrs: {
    date: attr(),
    schoolId: attr(),
    panoramicImageUrl: attr()
  },
})

export default Djob
